import { Bank, BankState, WriteBank } from './types';
import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { RootState, SET_ALERT_ERROR, SET_ALERT_SUCCESS } from '@/store/types';
import Vue, { VueConstructor } from 'vue';
import { ApiResponse } from '@/components/types';

export const FETCH_LIST = 'FETCH_BANK_LIST';
export const FETCH_USE_LIST = 'FETCH_BANK_USE_LIST';
export const GET_LIST = 'GET_BANK_LIST';
export const GET_BY_ID = 'GET_BANK_BY_ID';
export const GET_BY_NAME = 'GET_BANK_BY_NAME';
export const GET_BY_BANK_CODE = 'GET_BANK_BY_BANK_CODE';
export const UPDATE = 'UPDATE_BANK';
export const CREATE = 'CREATE_BANK';

const initialState = (): BankState => ({
  list: []
});

const getters: GetterTree<BankState, RootState> = {
  [GET_LIST]: (state) => state.list,
  [GET_BY_ID]: (state) => (id: string) => state.list.find((court) => court.id === id),
  [GET_BY_NAME]: (state) => (name: string) => state.list.find((item) => name.includes(item.name)),
  [GET_BY_BANK_CODE]: (state) => (bankCode: string) => state.list.find((item) => item.bankCode === bankCode)
};

const mutations: MutationTree<BankState> = {
  SET_LIST_ITEMS: (state: BankState, items: Bank[]) => {
    state.list = items;
  },
  UPDATE_ITEM: (state, item) => {
    const index = state.list.findIndex((entry) => entry.id === item.id);

    state.list.splice(index, 1);

    state.list = [
      ...state.list,
      item
    ];
  },
  ADD_ITEM: (state, item) => {
    state.list = [
      ...state.list,
      item
    ];
  },
  RESET: (state) => {
    const initial = initialState();
    Object.keys(initial).forEach((key) => {
      // @ts-ignore
      state[key] = initial[key];
    });
  }
};

const actions = (Vue: Vue | VueConstructor): ActionTree<BankState, RootState> => ({
  async [FETCH_LIST]({ commit }) {
    try {
      const response = await Vue.axios.get('api/bank/list', { responseType: 'json' });

      commit('SET_LIST_ITEMS', response.data);

      return { content: response.data };
    } catch (error) {
      return { error };
    }
  },
  [FETCH_USE_LIST]: async ({ dispatch }): Promise<ApiResponse> => {
    try {
      const response = await Vue.axios.get('api/bank/use-list', { responseType: 'json' });

      return { content: response.data };
    } catch (error) {
      return { error };
    }
  },
  [UPDATE]: async ({ commit, dispatch }, updateBank: WriteBank) => {
    try {
      await Vue.axios.post('api/commands/financial-administration/bank/update', updateBank, { responseType: 'json' });

      await dispatch(FETCH_LIST);
      commit(SET_ALERT_SUCCESS, true, { root: true });

      return { error: null };
    } catch (error) {
      commit(SET_ALERT_ERROR, error, { root: true });

      return { error };
    }
  },
  [CREATE]: async ({ commit, dispatch }, createBank: WriteBank) => {
    try {
      await Vue.axios.post('api/commands/financial-administration/bank/create', createBank, { responseType: 'json' });

      await dispatch(FETCH_LIST);
      commit(SET_ALERT_SUCCESS, true, { root: true });

      return {};
    } catch (error) {
      commit(SET_ALERT_ERROR, error, { root: true });

      return { error };
    }
  },
  SET_LIST({ commit }, { data }: { data: { banks: Bank[] } }) {
    commit('SET_LIST_ITEMS', data.banks);
  }
});

export default (instance: Vue | VueConstructor): Module<BankState, RootState> => ({
  namespaced: true,
  state: initialState(),
  getters,
  mutations,
  actions: actions(instance)
});
